import { render, staticRenderFns } from "./ProductQuantityElement.vue?vue&type=template&id=516a137c&"
import script from "./ProductQuantityElement.vue?vue&type=script&lang=js&"
export * from "./ProductQuantityElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports